import Axios from "axios";

const apiUrl = process.browser
  ? process.env.REACT_APP_API_URL
  : "http:" + process.env.REACT_APP_API_URL;

let fetchApi = Axios.create({
  baseURL: apiUrl,
  validateStatus: function(status) {
    return status < 500;
  }
});

let apiHelper = {
  getData(type, token, startDate, endDate) {
    return fetchApi
      .get(
        "/api/reports?type=" +
          type +
          "&startDate=" +
          startDate.replace(/-/g, "") +
          "&endDate=" +
          endDate.replace(/-/g, "") +
          "&sortBy=stats_date&sortType=desc",
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: "Bearer " + token
          }
        }
      )
      .then(response => {
        // console.log(response);
        return response;
      });
  },
  hasAccess(username, password) {
    return fetchApi
      .post("/api/login", "email=" + username + "&password=" + password, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
      .then(response => {
        // console.log(response);
        return response.data;
      });
  },
  logoutUser(token) {
    return fetchApi
      .post("/api/logout", "", {
        headers: {
          Authorization: "Bearer " + token
        }
      })
      .then(response => {
        // console.log(response);
        return response.data;
      });
  }
};

export default apiHelper;
